import React, { useEffect, useState, useCallback } from 'react';
import { Spinner, Cell } from 'react-mdl';
import {
    BOOKING_TYPE_AIRPORT_TRANSFER,
    BOOKING_TYPE_CHAUFFEUR_SERVICES,
    BOOKING_TYPE_CAR_RENTALS,
    BOOKING_TYPE_DEPARTURE_TRANSFER,
    BOOKING_TYPE_RETURN_TRANSFER
} from '../../const'
import axios from 'axios';
import moment from 'moment';
import DayCounter from '../../components/DayCounter';
import ProgressTraker from '../../components/ProgressTracker';
import Button from '../../components/SliderButton';
import ConfirmationModal from '../../components/ConfirmationModal'
import _ from 'lodash';
let intTimer;
const EnteringPage = (props) => {
    const { bId , vipType} = props.match.params
    const [buttonLabels, setButtonLabels] = useState([
        "On the way", "On location", "Passenger on board", "Passenger dropped off"
    ])

    const [actionTypes, setActionTypes] = useState([
        "on_the_way", "on_location", "passenger_onboard", "passenger_dropped_off"
    ])

    const [book, setBook] = useState()
    const [bookingcancelled, setBookingcancelled] = useState(false)
    const [updateDayCompleted, setUpdateDayCompleted] = useState(null)
    const [proSteps, setProSteps] = useState([])
    const [step, setStep] = useState(0)
    const [timeCount, setTimeCount] = useState(0)
    const [hoursDifference, setHoursDifference] = useState([])
    const [isSubmitting, setSubmitting] = useState(false)
    const [showConfirmationModal, setShowConfirmationModal] = useState(false)
    const [displayAlertText, setDisplayAlertText] = useState("")
    const [currentDay, setCurrentDay] = useState(1)
    const [showTenMinsAwayUpdate, setShowTenMinsAwayUpdate] = useState(false)

    useEffect(() => {
        async function fetchBookInfo() {
            const { bId } = props.match.params
            const result = await axios(
                process.env.REACT_APP_API_URL + "/api/v1/partners/" + bId
            );
            setBook(result.data.data)
            setShowTenMinsAwayUpdate(result.data.data.tenMinsAwayDriverUpdate)
        }
        if (props.location.state && props.location.state.book) {
            const { book } = props.location.state.book
            setBook(book)
            props.history.replace({ pathname: props.location.pathname, state: {} })
        } else {
            fetchBookInfo();
        }
    }, [step, setBook, props.history, props.location, props.match])

    useEffect(() => {
        if (!book) {
            return;
        }
        const fetchTime = async () => {
            const geo = `${book.pickUpLocation.lat},${book.pickUpLocation.lng}`;
            const { data } = await axios.post(process.env.REACT_APP_API_URL + "/api/v1/booking-timeZone", {
                eventTime: book.pickUpDate,
                coordinates: geo
            })
            let offSet = data.data.location.rawOffset + data.data.location.dstOffset
            var timeToEvent = data.data.eventTimeStamp * 1000
            var currentTime = new Date(
                (Math.floor(new Date(data.data.localTimeStamp * 1000) / 1000) +
                    offSet) *
                1000
            )
            var diffTime = timeToEvent - currentTime
            setTimeCount(diffTime)

            var duration = moment.duration(diffTime, 'milliseconds');

            var interval = 1000;
            setHoursDifference({
                days: duration.days(),
                hours: duration.hours(),
                mins: duration.minutes(),
                secs: duration.seconds()
            });

            intTimer = setInterval(() => {
                duration = moment.duration(duration - interval, 'milliseconds');

                setHoursDifference({
                    days: duration.days(),
                    hours: duration.hours(),
                    mins: duration.minutes(),
                    secs: duration.seconds()
                });

            }, interval);

        }
        fetchTime();


        if (book.durationType === 'daily' && book.days && book.days.length) {
            let day = 1
            for (var i in book.days) {
              let currentDate = moment.utc(new Date())
              let dayDate = moment.utc(book.days[i].pickUpDate).startOf('day')
              if (currentDate.isSameOrAfter(dayDate)) {
                day = parseInt(i) + 1
                setCurrentDay(parseInt(i) + 1)
              }
            }
        }

        if (
          book.type === BOOKING_TYPE_AIRPORT_TRANSFER ||
          book.type === BOOKING_TYPE_DEPARTURE_TRANSFER ||
          book.type === BOOKING_TYPE_RETURN_TRANSFER ||
          book.type === BOOKING_TYPE_CHAUFFEUR_SERVICES
        ) {
            if(vipType){
                setProSteps([
                    { id: 0, title: 'On site' },
                    { id: 1, title: 'Contact made' },
                    { id: 2, title: 'Service complete' },
                    // ...(isLastDay ? [] : [{ id: 4, title: 'Mark day complete' }]),
                  ])
                  setButtonLabels([
                    `On site at ${vipType}`,
                    'Contact made',
                    'Service complete',
                ])
                  setActionTypes([
                    `on_site`,
                    `contact_made`,
                    `service_complete`,
                  ])
            }else
          if (book.durationType !== "daily" || !book.days) {
            if (showTenMinsAwayUpdate) {
              setProSteps([
                { id: 0, title: "On my way" },
                { id: 1, title: "On location" },
                { id: 2, title: "On board" },
                { id: 3, title: "10 mins away" },
                { id: 4, title: "Drop off" },
              ]);
              setButtonLabels([
                "On the way",
                "On location",
                "Passenger on board",
                `I'm 10 mins away`,
                "Passenger dropped off",
              ]);
              setActionTypes([
                "on_the_way",
                "on_location",
                "passenger_onboard",
                "ten_mins_away",
                "passenger_dropped_off",
              ]);
            } else {
              setProSteps([
                { id: 0, title: "On my way" },
                { id: 1, title: "On location" },
                { id: 2, title: "On board" },
                { id: 3, title: "Drop off" },
              ]);
            }
          } else {
            if (showTenMinsAwayUpdate) {
              setProSteps([
                { id: 0, title: "On my way" },
                { id: 1, title: "On location" },
                { id: 2, title: "On board" },
                { id: 3, title: "10 mins away" },
                { id: 4, title: "Drop off" },
                { id: 5, title: "Completed" },
              ]);
              setButtonLabels([
                "On the way",
                "On location",
                "Passenger on board",
                `I'm 10 mins away`,
                "Passenger dropped off",
                "Mark day complete",
              ]);
              setActionTypes([
                "on_the_way",
                "on_location",
                "passenger_onboard",
                "ten_mins_away",
                "passenger_dropped_off",
                "completed",
              ]);
            } else {
              setProSteps([
                { id: 0, title: "On my way" },
                { id: 1, title: "On location" },
                { id: 2, title: "On board" },
                { id: 3, title: "Drop off" },
                { id: 4, title: "Completed" },
              ]);
              setButtonLabels([
                "On the way",
                "On location",
                "Passenger on board",
                "Passenger dropped off",
                "Mark day complete",
              ]);
              setActionTypes([
                "on_the_way",
                "on_location",
                "passenger_onboard",
                "passenger_dropped_off",
                "completed",
              ]);
            }
          }
        } else if (book.type === BOOKING_TYPE_CAR_RENTALS) {
          setProSteps([
            { id: 0, title: "On my way" },
            { id: 1, title: "On location" },
            { id: 2, title: "Delivered" },
          ]);

          setButtonLabels([
            "On the way",
            "On location",
            "Vehicle delivered",
          ]);
          setActionTypes(["on_the_way", "on_location", "delivered"]);
        }
    }, [book, setProSteps, props.match, props.history, setTimeCount, showTenMinsAwayUpdate])

    useEffect(() => {
        if (!book) {
            return;
        }
        if (book && book.bookingOperations.length > 0 && book.bookingOperations[0].actions.length > 0) {
            if (book.durationType !== 'daily' || !book.days) {
                let vipActions
                if(vipType){
                 vipActions = book.bookingOperations[0].actions.filter(action => action.service === `vip_${vipType}`)
                }
            const lastAction = !(vipActions?.length > 0) ? book.bookingOperations[0].actions[book.bookingOperations[0].actions?.length - 1] : vipActions[vipActions?.length - 1]
            const idx = actionTypes.findIndex((action) => {
                if (vipType === 'arrival') {
                  return action === lastAction.status && lastAction.service === 'vip_arrival';
                } else if (vipType === 'departure') {
                  return action === lastAction.status && lastAction.service === 'vip_departure';
                } else {
                  return action === lastAction.status;
                }
              });
              
            if (idx !== -1) {
                setStep(idx + 1)
            }
        } else {
          var actions = book.bookingOperations[0].actions.filter(function(el) {
            return el.day === currentDay
          })
          if (actions.length > 0) {
            const lastAction = actions[actions.length - 1];
            const idx = actionTypes.findIndex((action) => {
                if (vipType === 'arrival') {
                  return action === lastAction.status && lastAction.service === 'vip_arrival';
                } else if (vipType === 'departure') {
                  return action === lastAction.status && lastAction.service === 'vip_departure';
                } else {
                  return action === lastAction.status;
                }
              });
              
            if (idx !== -1) {
              setStep(idx + 1);
            }
          } else {
            var actions = book.bookingOperations[0].actions.filter(function (
              el
            ) {
              return !el.day;
            });
            if (actions.length > 0) {
              const lastAction = actions[actions.length - 1];
            //   const idx = actionTypes.findIndex(
            //     (action) => action === lastAction.status
            //   );
              const idx = actionTypes.findIndex((action) => {
                if (vipType === 'arrival') {
                  return action === lastAction.status && lastAction.service === 'vip_arrival';
                } else if (vipType === 'departure') {
                  return action === lastAction.status && lastAction.service === 'vip_departure';
                } else {
                  return action === lastAction.status;
                }
              });
              
              if (idx !== -1) {
                setStep(idx + 1);
              } else {
                setStep(0);
              }
            } else {
              setStep(0);
            }
          }
        } 
        } else {
            const { bId } = props.match.params
            props.history.push(`/${bId}/b`);
        }
    }, [actionTypes, props.history, props.match, setStep, book, currentDay])

    const nextStep = useCallback(async () => {

        setSubmitting(true)
        var duration = null
        if (book && book.bookingOperations[0].actions.length) {
            const lastAction = book.bookingOperations[0].actions[book.bookingOperations[0].actions.length - 1]
            if (lastAction.status === "accepted") {
                duration = null
            } else {
                const geo = `${book.pickUpLocation.lat},${book.pickUpLocation.lng}`;
                const { data } = await axios.post(process.env.REACT_APP_API_URL + "/api/v1/booking-timeZone", {
                    eventTime: lastAction.time,
                    coordinates: geo
                })
                let offSet = data.data.location.rawOffset + data.data.location.dstOffset
                var timeToEvent = data.data.eventTimeStamp * 1000
                var currentTime = new Date(
                    (Math.floor(new Date(data.data.localTimeStamp * 1000) / 1000) +
                        offSet) *
                    1000
                )
                var diffTime = currentTime - timeToEvent
                duration = moment.duration(diffTime, 'milliseconds');
            }
        }
        if (await checkStepStatus()) {
            setDisplayAlertText('This action cannot be completed at this time. Please wait and try again when you are on your way.')
            setShowConfirmationModal(true)
        } else if (duration && duration.seconds() <= 30 && duration.minutes() < 1 && duration.hours() === 0 && duration.days() === 0) {
            if ((book.type === BOOKING_TYPE_AIRPORT_TRANSFER || book.type === BOOKING_TYPE_DEPARTURE_TRANSFER || book.type === BOOKING_TYPE_RETURN_TRANSFER || book.type === BOOKING_TYPE_CHAUFFEUR_SERVICES) && actionTypes[step] !== 'completed') {
                switch (actionTypes[step]) {
                    case "on_location":
                        setDisplayAlertText('This action cannot be completed at this time. Please wait and try again when you are on location.')
                        break;
                    case "passenger_onboard":
                        setDisplayAlertText('This action cannot be completed at this time. Please wait and try again when the passenger is on board.')
                        break;
                    case "ten_mins_away":
                        setDisplayAlertText('This action cannot be completed at this time. Please wait and try again when you are 10 mins away from the destination.')
                        break;
                    case "passenger_dropped_off":
                        setDisplayAlertText('This action cannot be completed at this time. Please wait and try again when the passenger has been dropped off.')
                        break;
                    default:
                        setDisplayAlertText('This action cannot be completed at this time. Please wait and try again later')
                        break;
                }
            } else if (book.type === BOOKING_TYPE_CAR_RENTALS) {
                switch (actionTypes[step]) {
                    case "on_location":
                        setDisplayAlertText('This action cannot be completed at this time. Please wait and try again when you are on location.')
                        break;
                    case "delivered":
                        setDisplayAlertText('This action cannot be completed at this time. Please wait and try again when vehicle has been delivered.')
                        break;
                    default:
                        setDisplayAlertText('This action cannot be completed at this time. Please wait and try again later')
                        break;
                }
            }
            setShowConfirmationModal(true)
        } else {
            navigator.geolocation.getCurrentPosition(async function (pos) {
                const geo = `${pos.coords.latitude},${pos.coords.longitude}`;

                const { bId , vipType} = props.match.params
                const isArrival = vipType === 'arrival';
                const service = vipType === 'arrival' ? 'vip_arrival' : 'vip_departure';
                await axios.post(process.env.REACT_APP_API_URL + "/api/v1/partners/" + (vipType ? "greeter/" : "") + bId, {
                    action: actionTypes[step],
                    geoLocation: geo,
                    isLiveLocation: true,
                    ...(book.durationType === 'daily' && book.days
                    ? { day: currentDay }
                    : {}),
                    ...(vipType && {
                        isArrival: isArrival,
                        service: service
                      })
                })
                setSubmitting(false)
                setStep(step + 1)
            }, async function (error) {
                if (error.code === error.PERMISSION_DENIED) {
                    const { bId , vipType} = props.match.params
                    const isArrival = vipType === 'arrival';
                    const service = vipType === 'arrival' ? 'vip_arrival' : 'vip_departure';
                    const geo = `51.4933,-0.1684`;
                    await axios.post(process.env.REACT_APP_API_URL + "/api/v1/partners/" + (vipType ? "greeter/" : "") + bId, {
                        action: actionTypes[step],
                        geoLocation: geo,
                        isLiveLocation: false,
                        ...(book.durationType === 'daily' && book.days
                        ? { day: currentDay }
                        : {}),
                        ...(vipType && {
                            isArrival: isArrival,
                            service: service
                          })
                    })
                    setSubmitting(false)
                    setStep(step + 1)
                }
            })
        }
    }, [book, step, setStep, props.match, props.history, actionTypes])

    const showDetail = useCallback(() => {
        const { bId } = props.match.params
        props.history.push({
            pathname: `/${vipType ? `${vipType}/` : ''}${bId}/d`,
            state: {
                book
            }
        });
    }, [props.match, props.history, book])

    const onConfirmationModal = async type => {
        setShowConfirmationModal(false)
        setSubmitting(false)
    }
    const carRentalsDuration = () => {
        if (book && book.dropOffDate && book.pickUpDate) {
            let numberOfHours = moment(book.dropOffDate).diff(book.pickUpDate)
            let duration = moment.duration(numberOfHours, 'milliseconds')
            let numOfDays = moment(
            moment
                .utc(book.dropOffDate)
                .endOf('day')
                .format()
            ).diff(
            moment(
                moment
                .utc(book.pickUpDate)
                .startOf('day')
                .format()
            ),
            'days'
            )
        
            if (duration.days() <= 0) {
            return 1
            } else if (
            duration.days() < numOfDays ||
            (duration.days() === numOfDays &&
                (duration.hours() > 2 ||
                (duration.hours() === 2 && duration.minutes() > 0)))
            ) {
            return parseFloat(numOfDays) + 1
            } else {
            return duration.days()
            }
        }
    }
    const checkStepStatus = async () => {
        const geo = `${book.pickUpLocation.lat},${book.pickUpLocation.lng}`;
        const { data } = await axios.post(process.env.REACT_APP_API_URL + "/api/v1/booking-timeZone", {
            eventTime:
            book.durationType === 'daily' && book.days
              ? book.days[currentDay - 1].pickUpDate
              : book.pickUpDate,
            coordinates: geo
        })
        let offSet = data.data.location.rawOffset + data.data.location.dstOffset
        var timeToEvent = data.data.eventTimeStamp * 1000
        var currentTime = new Date((Math.floor(new Date(data.data.localTimeStamp * 1000) / 1000) + offSet) * 1000)
        var diffTime = timeToEvent - currentTime
        setTimeCount(diffTime)

        var duration = moment.duration(diffTime, 'milliseconds');
        if (duration && duration.days() === 0 && duration.hours() < 5) {
            return false
        } else {
            return true
        }
    }
    if (!book) {
        return (
            <div className="page-container landing-grid flex-vertical justify-center text-center align-center">
                <Cell col={12}>
                    <Spinner singleColor />
                </Cell>
            </div>)
    }
    if ((book.status === "cancelled_by_agent") || (book.status === "cancellation_accepted_by_agent") || (book.status === "cancellation_requested_by_client")) {
        return (
            <div className="cancelledBookingDiv">
                <img src="/images/icons/coution.png" alt="icon coution" />
                <p >The booking was cancelled</p>
            </div>
        )
    }
    return (
        <div className="page-container landing-grid flex-vertical justify-between">
            <Cell col={12}>
                {
                    !vipType &&
                (<div className={`tracker-area flex ${step <= 1 && timeCount > 0 ? "justify-between" : "justify-end"}`}>
                    {timeCount > 0 && <DayCounter timeCount={timeCount} displayState={step > 1 ? false : true}></DayCounter>}
                    <p className="color-grey">#{book.number}</p>
                </div>)
                }

                <div className="booking-content">
                    <div className="car-info">
                        <p className="car-info--time">{(book.durationType !== 'daily' || !book.days) ? moment.utc(vipType === 'departure' ? book?.meetAndAssist?.departure?.pickUpDate : book.pickUpDate).format("dddd Do MMMM, LT") :moment.utc(book.days[currentDay - 1].pickUpDate).format("dddd Do MMMM, LT") }</p>
                        {!vipType && (<p className="car-info--location">{`${book.globalVehicle.brandName} ${book.globalVehicle.modelName}`}</p>)}
                    </div>

                    <div className="pre-booking-detail">
                        <p className="content" onClick={showDetail}>
                            View booking details
                        </p>
                    </div>

                    <div className="driver-info">
                        <p className="title">
                            {book.type === BOOKING_TYPE_CAR_RENTALS ? "Driver" : "Passenger"}
                        </p>
                        <p className="content">
                            {book.type === BOOKING_TYPE_CAR_RENTALS ? `${book.driversInfo[0].title} ${book.driversInfo[0].lastName}` : `${book.passengerInfo.title} ${book.passengerInfo.lastName}`}
                        </p>
                    </div>

                    <div className="path-info only-content">
                        <div className="location--start flex">
                            <span className="material-icons long-line">
                                stop_circle
                            </span>
                            {!vipType || vipType === 'arrival'
                            ?
                            <span className="content">{(book.durationType !== 'daily' || !book.days) ? book.pickUpLocation.fullAddress : book.days[currentDay - 1].pickUpLocation.fullAddress}</span>
                            :
                            <span className="content">{(book.durationType !== 'daily' || !book.days) ? book.dropOffLocation.fullAddress : book.days[currentDay - 1].dropOffLocation.fullAddress}</span>
                            }
                        </div>

                        {book.type === BOOKING_TYPE_AIRPORT_TRANSFER || book.type === BOOKING_TYPE_DEPARTURE_TRANSFER || book.type === BOOKING_TYPE_RETURN_TRANSFER &&
                            <div className="location--end flex">
                                <span className="material-icons drop--off location">
                                    location_on
                                </span>
                                <span className="content">{book.dropOffLocation.fullAddress}</span>
                            </div>
                        }

                        {book.type === BOOKING_TYPE_CHAUFFEUR_SERVICES &&
                            <div className="location--end flex">
                                <span className="material-icons drop--off">
                                    timer
                                </span>
                                <span className="content">{book.durationType === "hourly" ? book.duration + " hours" : `${book.days.length} days`}</span>
                            </div>
                        }

                        {book.type === BOOKING_TYPE_CAR_RENTALS &&
                            <div className="location--end flex">
                                <span className="material-icons drop--off location">
                                    location_on
                                </span>
                                <span className="content">{`${carRentalsDuration()} day${
                              carRentalsDuration() > 1 ? 's' : ''
                            }`} </span>
                            </div>
                        }
                    </div>

                    {/* {!bookingcancelled && <ProgressTraker steps={proSteps} step={step}></ProgressTraker>} */}
                    <ProgressTraker steps={proSteps} step={step}></ProgressTraker>
                </div>
            </Cell>

            <Cell col={12} >
                <Button isLoading={isSubmitting} onClick={nextStep} hide={proSteps.length > step ? false : true}>{buttonLabels[step]}</Button>
                {/* <Button
                    isLoading={isSubmitting}
                    onClick={nextStep}
                    hide={bookingcancelled ? bookingcancelled : proSteps.length > step ? false : true}
                >
                    {buttonLabels[step]}
                </Button> */}
            </Cell>
            <ConfirmationModal
                onHide={() => {
                    setShowConfirmationModal(false)
                }}
                handleFunction={onConfirmationModal}
                show={showConfirmationModal}
                displayText={displayAlertText}
            />
        </div>

    );
}
export default EnteringPage;